import { inject, injectable } from 'inversify';
import { SockJsAdapter, Connection } from '@dealroadshow/socket-frontend-sdk';
import DITypes from './DI/types';
import url from '@/creditflowresearch/infrastructure/url';

@injectable()
export class SocketAdapter extends SockJsAdapter {
  constructor(
    @inject(DITypes.SocketConnection) connection: Connection,
  ) {
    super(url.getAskAiRpcUrl(), connection);
  }
}
